<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-building-o"></i> {{ _('Company profile') }}</h3>
        </div>
      </div>
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition-group name="fade">
          <div v-bind="tabPanel('general')" class="tab-pane active" id="general" v-if="isTabActive('general')" key="general">
            <div class="row hidden-print">
              <div class="col-xs-12">
                <h3>{{ _('Company details') }}</h3>
              </div>
            </div>
            <div class="row hidden-print">
              <div class="col-sm-6 leftcol">
                <div class="form-group languageversioned">
                  <label for="companyname">{{ _('Company name') }}</label>
                  <input type="text" class="form-control" id="companyName" :placeholder="_('Company name')" name="companyname" v-model.trim="settings.companyname">
                </div>
                <div class="form-group languageversioned">
                  <label for="shopMarketingname">{{ _('Company marketing name') }}</label>
                  <input name="marketingname" type="text" class="form-control" id="shopMarketingname" :placeholder="_('Enter the company marketing name')" v-model="settings.marketingname" />
                </div>
                <p>{{ _('If you want to use a separate marketing name for your company that is different from the company name, you can set it here.') }}</p>
                <div class="form-group">
                  <label for="companyid">{{ _('Company id') }}</label>
                  <input type="text" class="form-control" id="companyId" :placeholder="_('1234567-8')" name="companyid" v-model.trim="settings.companyid">
                </div>
                <div class="form-group">
                  <label for="companyaddress">{{ _('Street address') }}</label>
                  <textarea class="form-control" id="companyAddress" :placeholder="_('Streetname 2')" name="companyaddress" v-model="settings.companyaddress"></textarea>
                </div>
                <div class="form-group">
                  <label for="companyzip">{{ _('Zip code') }}</label>
                  <input type="text" class="form-control" id="companyZip" :placeholder="_('01234')" name="companyzip" v-model.trim="settings.companyzip">
                </div>
                <div class="form-group">
                  <label for="companycity">{{ _('City') }}</label>
                  <input type="text" class="form-control" id="companyCity" :placeholder="_('Sampleville')" name="companycity" v-model.trim="settings.companycity">
                </div>
                <div class="form-group">
                  <label for="country">{{ _('Country') }}</label>
                  <select class="form-control" name="country" id="customerCountry" v-model="settings.companycountry">
                    <option value="FI">{{ countries['FI'] }}</option>
                    <template v-for="(country, id) in countries" :key="id">
                      <option v-if="isPriorityCountry(id) && id !== 'FI'" :value="id">{{ country }}</option>
                    </template>
                    <option class="select-separator" disabled="disabled">────────────</option>
                    <option v-for="(country, id) in countries" :value="id">{{ country }}</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6 leftcol">
                <div class="form-group">
                  <label for="companyurl">{{ _('Website') }}</label>
                  <input type="text" class="form-control" id="companyUrl" :placeholder="_('www.website.com')" name="companyurl" v-model.trim="settings.companyurl">
                </div>
                <div class="form-group">
                  <label for="companyemail">{{ _('Email') }}</label>
                  <input type="email" class="form-control" id="companyEmail" :placeholder="_('address@company.com')" name="companyemail" v-model.trim="settings.companyemail">
                </div>
                <div class="form-group">
                  <label for="companyphone">{{ _('Phone number') }}</label>
                  <input type="text" class="form-control" id="companyPhone" :placeholder="_('040 1234567')" name="companyphone" v-model.trim="settings.companyphone">
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('billing')" class="tab-pane active" id="billing" v-if="isTabActive('billing')" key="billing">
            <div class="row">
              <div class="col-sm-6 leftcol">
                <h3>{{ _('Billing info') }}</h3>
                <div class="form-group">
                  <p>{{ _('These details are used to send Johku commission invoices.') }}</p>
                  <label for="companyevoice">{{ _('E-Invoice Address') }}</label>
                  <input type="text" class="form-control" id="companyEvoice" placeholder="" name="companyevoice" v-model.trim="settings.companyevoice">
                </div>
                <div class="form-group">
                  <label for="evoiceint">{{ _('E-Invoice Intermediary') }}</label>
                  <select class="form-control" name="evoiceint" id="customerEvoiceInt" v-model="settings.companyevoiceint">
                    <option value="">{{ _('Select') }}</option>
                    <option v-for="int in evoiceInt" :value="int.id">{{ int.name }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="billingemail">{{ _('Email') }}</label>
                  <input type="email" class="form-control" id="billingEmail" placeholder="" name="billingemail" v-model.trim="settings.billingemail">
                </div>
                <div class="form-group">
                  <label for="companymark">{{ _('Mark') }}</label>
                  <input type="text" class="form-control" id="companyMark" placeholder="" name="companymark" v-model="settings.companymark">
                </div>
                <div class="form-group">
                  <label for="companyyourreference">{{ _('Your reference') }}</label>
                  <input type="text" class="form-control" id="companyYourReference" placeholder="" name="companyyourreference" v-model="settings.companyyourreference">
                </div>
              </div>
              <div class="col-sm-6 rightcol">
                <h3>{{ _('Bank details') }}</h3>
                <div class="form-group">
                  <p>{{ _('These details are used in the invoices sent from your shop.') }}</p>
                  <label for="pay_option1_bank">{{ _('Bank') }}</label>
                  <input type="text" class="form-control" id="payOption1Bank" :placeholder="_('for example Nordea')" name="pay_option1_bank" v-model.trim="settings.pay_option1_bank" />
                </div>
                <div class="form-group">
                  <label for="pay_option1_iban">{{ _('IBAN') }}</label>
                  <input type="text" class="form-control" id="payOption1Iban" :placeholder="_('for example FI1234567890123456')" name="pay_option1_iban" v-model.trim="settings.pay_option1_iban" />
                </div>
                <div class="form-group">
                  <label for="pay_option1_bic">{{ _('BIC') }}</label>
                  <input type="text" class="form-control" id="payOption1Bic" :placeholder="_('for example NDEAFIHH')" name="pay_option1_bic" v-model.trim="settings.pay_option1_bic" />
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-sm-6">
                <h3>{{ _('Transaction reports') }}</h3>
                <select class="form-control" id="selectMonth" v-model="selectedReportMonth">
                  <option value="-1">{{ _('Select month...') }}</option>
                  <option v-for="month in reportMonths" :value="month"><template v-if="month.match(/\./)">&nbsp;&nbsp;&nbsp;</template>{{ month }}</option>
                </select><br />
                <button class="btn btn-success" id="downloadTransactionReport" type="button" v-on:click="downloadTransactionReport" :disabled="selectedReportMonth === '-1'"><i class="fa fa-fw fa-download"></i> {{ _('Download monthly transaction report') }}</button>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('details')" class="tab-pane active" id="details" v-if="isTabActive('details')" key="details">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('Details') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group" data-search="industry">
                  <label for="companyindustries">{{ _('Industry') }}</label>
                  <v-select :options="selectableIndustries" v-model="industries" multiple label="title" keys="['title', 'id']" :placeholder="_('Type to search industries')">
                    <template v-slot:no-options="{ searching }">
                      <template v-if="searching">
                        {{ _('No results found.') }}
                      </template>
                      <template v-else>{{ _('Type to search industries') }}</template>
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group languageversioned" data-search="short-description">
                  <label for="companydescription">{{ _('Short description') }}</label>
                  <editor v-model="settings.companydescription" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group languageversioned" data-search="general-description">
                  <label for="companylongdescription">{{ _('General description') }}</label>
                  <editor v-model="settings.companylongdescription" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="latitude">{{ _('Latitude') }}</label>
                  <input type="text" class="form-control" id="latitude" :placeholder="_('Enter the latitude')" name="latitude" v-model="settings.latitude" />
                </div>
                <div class="form-group">
                  <label for="longitude">{{ _('Longitude') }}</label>
                  <input type="text" class="form-control" id="longitude" :placeholder="_('Enter the longitude')" name="longitude" v-model="settings.longitude" />
                </div>
                <div class="form-group">
                  <button type="button" class="btn btn-success" id="pickLocationButton" v-on:click="pickLocation"><i class="fa fa-fw fa-map-marker"></i> {{ _('Pick location from the map') }}</button>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('some')" class="tab-pane active" id="some" v-if="isTabActive('some')" key="some">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('Social Profiles') }}</h3>
              </div>
              <div class="col-sm-6 leftcol">
                <div class="form-group" data-search="facebook">
                  <label for="profile_facebook">{{ _('Facebook') }}</label>
                  <div class="input-group">
                    <span class="input-group-addon" id="basic-addon1"><i class="fa fa-fw fa-facebook"></i></span>
                    <input type="text" class="form-control" placeholder="https://www.facebook.com/..." name="profile_facebook" aria-describedby="basic-addon1" v-model="settings.profile_facebook" />
                  </div>
                </div>
                <div class="form-group" data-search="x">
                  <label for="profile_twitter">{{ _('X') }}</label>
                  <div class="input-group">
                    <span class="input-group-addon" id="basic-addon2"><i class="fa fa-fw fa-x"></i></span>
                    <input type="text" class="form-control" placeholder="https://x.com/..." name="profile_twitter" aria-describedby="basic-addon2" v-model="settings.profile_twitter" />
                  </div>
                </div>
                <div class="form-group" data-search="linkedin">
                  <label for="profile_linkedin">{{ _('LinkedIn') }}</label>
                  <div class="input-group">
                    <span class="input-group-addon" id="basic-addon3"><i class="fa fa-fw fa-linkedin"></i></span>
                    <input type="text" class="form-control" placeholder="https://www.linkedin.com/..." name="profile_linkedin" aria-describedby="basic-addon3" v-model="settings.profile_linkedin" />
                  </div>
                </div>
                <div class="form-group" data-search="instagram">
                  <label for="profile_google">{{ _('Instagram') }}</label>
                  <div class="input-group">
                    <span class="input-group-addon" id="basic-addon4"><i class="fa fa-fw fa-instagram"></i></span>
                    <input type="text" class="form-control" placeholder="https://www.instagram.com/..." name="profile_instagram" aria-describedby="basic-addon5" v-model="settings.profile_instagram" />
                  </div>
                </div>
                <div class="form-group" data-search="youtube">
                  <label for="profile_google">{{ _('Youtube') }}</label>
                  <div class="input-group">
                    <span class="input-group-addon" id="basic-addon4"><i class="fa fa-fw fa-youtube"></i></span>
                    <input type="text" class="form-control" placeholder="https://www.youtube.com/..." name="profile_youtube" aria-describedby="basic-addon5" v-model="settings.profile_youtube" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('images')" class="tab-pane active" id="images" v-if="isTabActive('images')" key="images">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('Images') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 leftcol">
                <label>{{ _('Profile picture') }}</label>
                <div id="profileupload">
                  <image-slot :file-id="settings.profile_id" :ext="settings.profile_ext" :owner-key="uploadOwnerKey" upload-slot="profile" input-id="profileImageUpload" image-element-id="companyImage" remove-button-id="removeImageButton" v-on:upload="queueUploads($event, 'profile')" v-on:library="chooseFromLibrary('profile')" v-on:remove="removeImage('profile')" />
                </div>
                <hr />
                <p>{{ _('The Storefront profile picture is used in certain payment methods, the main menu and as the browser\'s favorite icon. If the image is not a square, it will be cropped centrally.') }}</p>
              </div>
              <div class="col-md-4 rightcol">
                <label>{{ _('Storefront logo') }}</label>
                <div id="storefrontlogoupload">
                  <image-slot :file-id="settings.storefrontlogo_id" :ext="settings.storefrontlogo_ext" :owner-key="uploadOwnerKey" upload-slot="storefrontlogo" input-id="storefrontLogoUpload" image-element-id="storefrontLogo" remove-button-id="removeStorefrontLogoButton" v-on:upload="queueUploads($event, 'storefrontlogo')" v-on:library="chooseFromLibrary('storefrontlogo')" v-on:remove="removeImage('storefrontlogo')" />
                </div>
                <hr />
                <p>{{ _('Recommended maximum size: 230 x 130 px.') }}</p>
              </div>
              <div class="col-md-4 rightcol">
                <label>{{ _('Logo') }}</label>
                <div id="logoupload">
                  <image-slot :file-id="settings.file_id" :ext="settings.file_ext" :owner-key="uploadOwnerKey" upload-slot="logo" input-id="logoImageUpload" image-element-id="logoImage" remove-button-id="removeLogoButton" v-on:upload="queueUploads($event, 'logo')" v-on:library="chooseFromLibrary('logo')" v-on:remove="removeImage('logo')" />
                </div>
                <p>{{ _('Recommended maximum size: 230 x 130 px.') }}</p>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-lg-6 leftcol">
                <h3>{{ _('Main image') }}</h3>
                <div id="fileupload">
                  <image-slot :file-id="settings.mainimage_id" :ext="settings.mainimage_ext" :owner-key="uploadOwnerKey" upload-slot="mainimage" input-id="mainImageUpload" image-element-id="mainImage" remove-button-id="removeMainImageButton" v-on:upload="queueUploads($event, 'mainimage')" v-on:library="chooseFromLibrary('mainimage')" v-on:remove="removeImage('main')" />
                </div>
              </div>
              <div class="col-lg-6 rightcol" data-search="additional-images">
                <h3>{{ _('Additional images') }}</h3>
                <image-gallery id="additionalImages" v-if="settings" v-model:images="settings.sharedFile" :owner-key="uploadOwnerKey" upload-slot="gallery" :empty-text="_('The company profile has no additional images.')" input-id="additionalImageUpload" :show-details="false" v-on:upload="queueUploads($event, 'gallery')" v-on:library="chooseFromLibrary('gallery', { multiple: true, max: $event })" v-on:remove="removeImage($event)" />
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('account')" class="tab-pane active" id="account" v-if="isTabActive('account') && canAccessAccountTab" key="account">
            <div class="row">
              <div class="col-sm-3">
                <h3>{{ _('Johku Merchant Account') }}</h3>
                <label for="shopId">{{ _('Shop ID') }}</label>
                <div class="input-group" id="shopId">
                  <input class="form-control" type="text" :value="shopId" readonly />
                  <span class="input-group-btn">
                    <button class="btn btn-default" type="button" v-on:click="copyShopIdToClipboard"><i class="fa fa-fw fa-copy"></i> {{ _('Copy') }}</button>
                  </span>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-sm-6" data-search="johku-max">
                <johku-max-subscription></johku-max-subscription>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-sm-6" data-search="deactivation">
                <div id="deactivation" v-if="!parseInt(settings.disabled)">
                  <h3>{{ _('Johku deactivation') }}</h3>
                  <p>{{ _('If you want to temporarily stop product sales, you can do it here.') }}</p>
                  <p><strong>{{ _('Note! The shop is deactivated immediately but you will still receive a bill for this month\'s transactions.') }}</strong></p>
                  <button class="btn btn-warning" type="button" id="deactivate" v-on:click="deactivateShop"><i class="fa fa-fw fa-ban"></i> {{ _('Deactivate Johku') }}</button>
                </div>
                <div id="activation" v-else>
                  <h3>{{ _('Johku activation') }}</h3>
                  <p>{{ _('If you are ready to continue using Johku, you can activate the shop here.') }}</p>
                  <button class="btn btn-success" type="button" id="activate" v-on:click="activateShop"><i class="fa fa-fw fa-play"></i> {{ _('Activate Johku') }}</button>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-sm-6" data-search="contract-termination">
                <div id="destruction" v-if="!parseInt(license.cancelled)">
                  <h3>{{ _('Contract termination') }}</h3>
                  <p>{{ _('If you no longer want to use Johku and want to destroy the shop permanently and irreversibly, you can do it here.') }}</p>
                  <p><strong>{{ _('Note! The shop will be deleted at the start of the next billing period, which is at the end of the month.') }}</strong></p>
                  <button class="btn btn-danger" type="button" id="deactivate" v-on:click="destroyShopDialog"><i class="fa fa-fw fa-trash"></i> {{ _('Permanently delete your Johku') }}</button>
                </div>
                <div id="activation" v-else>
                  <div class="alert alert-danger">
                    <strong>{{ _('This Johku has been marked for deletion at the start of the next billing period, which is at the end of the month.') }}</strong>
                  </div>
                  <h3>{{ _('Cancel deletion') }}</h3>
                  <p>{{ _('If you have reconsidered, you can still cancel the deletion.') }}</p>
                  <button class="btn btn-success" type="button" id="canceldeletion" v-on:click="activateShop"><i class="fa fa-fw fa-play"></i> {{ _('Cancel the deletion of your Johku') }}</button>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <nav class="save-bar">
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right">
            <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import evoice from '~/lib/evoice'
import settingseditors from '~/lib/settingseditors'
import { LocationSelector, Editor, JohkuMaxSubscription } from '#components'
import uploadaware from '~/lib/uploadaware'
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'

export default {
  data () {
    return {
      allIndustries: null,
      selectedReportMonth: '-1',
      firstInvoiceTs: null,
      license: {}
    }
  },
  mixins: [components, evoice, settingseditors, uploadaware],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'general', label: this._('General') },
        { id: 'billing', label: this._('Billing info') },
        { id: 'details', label: this._('Details') },
        { id: 'some', label: this._('Social media') },
        { id: 'images', label: this._('Images') },
        { id: 'account', label: this._('Johku Merchant Account'), hidden: !this.canAccessAccountTab }
      ])
    },
    uploadOwner () {
      // Shared with StorefrontSettings, which edits the same settings images
      return { type: 'settings', id: 1, label: this._('Company profile'), open: null }
    },
    ...mapGetters(['countries', 'userData']),
    settings: {
      get () {
        return this.localSettings ? this.localSettings : this.shopSettings(this.shopId)
      },
      set (newValue) {
        this.localSettings = newValue
      }
    },
    canAccessAccountTab () {
      return this.userData && this.userData.userlevel >= 7
    },
    selectableIndustries () {
      if (!this.allIndustries) {
        return []
      }
      return Object.keys(this.allIndustries).map((k) => { return { id: k, title: this.allIndustries[k] }})
    },
    industries: {
      get () {
        if (!this.settings || !this.settings.companyindustries) {
          return []
        }
        return this.settings.companyindustries.split(';').filter(i => i).map(i => this.selectableIndustries.find(si => si.id === i))
      },
      set (newValue) {
        this.settings.companyindustries = newValue.filter(i => i).map(i => i.id).join(';')
      }
    },
    reportMonths () {
      let months = []
      let minDate = DateTime.fromSeconds(Number(this.firstInvoiceTs), { zone: this.timezone }).startOf('month')
      const maxDate = DateTime.now({ zone: this.timezone }).startOf('month')
      const now = DateTime.now({ zone: this.timezone })
      while(maxDate >= minDate) {
        months.unshift(minDate.toFormat('M/yyyy'))
        minDate = minDate.plus({ months: 1 })
      }
      return months
    }
  },
  methods: {
    isPriorityCountry (id) {
      return ['SE', 'NO', 'DK', 'EE', 'RU'].indexOf(id) !== -1
    },
    async copyShopIdToClipboard () {
      try {
        await this.$copyText(this.shopId)
        this.showNotification(this._('Shop ID copied to clipboard!'))
      } catch (e) {
        this.showError(e)
      }
    },
    shopSettings (shopId) {
      return this.allSettings[shopId + '-' + this.version] || {} // Note: here we have to use version
    },
    activateShop () {
      this.toggleShop('activate')
    },
    deactivateShop () {
      this.toggleShop('deactivate')
    },
    async sendDestroyCode () {
      let response
      try {
        response = await axios.patch(this.baseDomain + this.shopId + '/license/1.json?apikey=' + this.apiKey, { id: 1, destroycode: true })
      } catch(e) {
        this.showError(this._('There was an error sending the confirmation code.'))
      }
    },
    destroyShopDialog () {
      this.sendDestroyCode()
      this.showDialog({
        title: this._('Contract termination'),
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Permanently delete your Johku'),
            class: 'danger',
            icon: 'trash',
            requiredFields: ['shopId', 'code'],
            handler: (data) => {
              this.destroyShop(data)
            }
          }
        ],
        fields: [
          {
            type: 'text',
            name: 'shopId', 
            title: this._('Enter the shop identifier of this shop'),
          },
          {
            type: 'text',
            name: 'code',
            title: this._('Enter the code we sent to your email'),
          }
        ],
        width: 800
      })
    },
    async destroyShop (params) {
      if (this.shopId !== params.shopId) {
        this.showError(this._('The shop identifier is incorrect!'))
        return
      }
      const data = {
        cancelled: 1,
        code: params.code
      }
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/license/1.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(this._('The operation failed!'))
        return
      }
      setTimeout(function() { window.location.reload() }, 1000)
    },
    async toggleShop (action) {
      const data = {
        disabled: action === 'activate' ? '0' : '1'
      }
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/license/1.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(this._('The operation failed!'))
        return
      }
      if (action === 'activate') {
        this.showNotification(this._('Shop activated!'))
      } else {
        this.showNotification(this._('Shop deactivated!'))
      }
      setTimeout(function() { window.location.reload() }, 1000)
    },
    async loadLicenseData () {
      let response
      let hasErrors = false
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/license.json?firstinvoice=true&apikey=' + this.apiKey)
        this.firstInvoiceTs = response.data
      } catch(e) {
        this.firstInvoiceTs = DateTime.now().toUnixInteger()
        hasErrors = true
      }
      /*
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/license.json?unpaid=true&apikey=' + this.apiKey)
          this.unpaidCommissions = response.data
      } catch(e) {
        hasErrors = true
      }
      */
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/license.json?apikey=' + this.apiKey)
        this.license = response.data
      } catch(e) {
        hasErrors = true
      }
      if (hasErrors) {
        this.showError(this._('Error loading license data! Please try again.'))
      }
    },
    downloadTransactionReport () {
      const m = String(this.selectedReportMonth)
      if (!this.reportMonths.includes(m)) {
        return
      }
      window.open(this.baseDomain + this.shopId + '/transactionreport/' + m.replace('\/', '-') + '.xlsx?apikey=' + this.apiKey)
    },
    pickLocation () {
      this.showModal('locationselector', LocationSelector, {
        props: {
          defaultLat: this.settings.latitude,
          defaultLng: this.settings.longitude,
          defaultAddress: this.settings.companyaddress + ' ' + this.settings.companycity,
          settings: this.settings,
          locale: this.shortLocale
        },
        events: {
          selectLocation: this.locationSelected
        },
        handlers: {},
        width: 800
      })
    },
    locationSelected (data) {
      this.settings.latitude = data.lat
      this.settings.longitude = data.lng
    },
    close () {
      if (this.component && this.component.initData && this.component && this.component.initData.modal) {
        this.$emit('close')
      } else {
        this.EventBus.$emit('hideDetailsColumn', {
          shopId: this.shopId
        })
      }
    },
    async loadIndustries () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/settings.json?industries=true&apikey=' + this.apiKey)
      } catch(e) {
        console.log(e)
        return
      }
      this.allIndustries = response.data
    },
    // Puts a file uploaded through the upload queue in its place (lib/uploadaware.js)
    applyUploadResult (slot, file) {
      if (!this.settings || !file) {
        return
      }
      if (slot === 'profile') {
        this.settings.profile_ext = file.ext
        this.settings.profile_id = file.id
      } else if (slot === 'storefrontlogo') {
        this.settings.storefrontlogo_ext = file.ext
        this.settings.storefrontlogo_id = file.id
      } else if (slot === 'logo') { // The logo lives in file_id because legacy
        this.settings.file_ext = file.ext
        this.settings.file_id = file.id
      } else if (slot === 'mainimage') {
        this.settings.mainimage_ext = file.ext
        this.settings.mainimage_id = file.id
      } else if (slot === 'gallery') {
        if (!Array.isArray(this.settings.sharedFile)) {
          this.settings.sharedFile = []
        }
        if (this.settings.sharedFile.findIndex(i => String(i.id) === String(file.id)) === -1) {
          this.settings.sharedFile.push({ id: file.id })
        }
      }
    },
    removeImage(image) {
      if (image === 'main') { // Remove main image
        this.settings.mainimage_id = null
        this.settings.mainimage_ext = null
      } else if (image === 'profile') { // Remove profile image
        this.settings.profile_id = null
        this.settings.profile_ext = null
      } else if (image === 'storefrontlogo') { // Remove storefront logo image
        this.settings.storefrontlogo_id = null
        this.settings.storefrontlogo_ext = null
      } else if (image === 'logo') { // Remove logo image (lives in file_id because legacy)
        this.settings.file_id = null
        this.settings.file_ext = null
      } else {
        this.settings.sharedFile = this.settings.sharedFile.filter(i => i.id !== image.id)
      }
    },
    getSaveData () {
      const exportFields = [
        'id', 
        'companyname',
        'marketingname',
        'companyid',
        'companyaddress',
        'companyzip',
        'companycity',
        'companycountry',
        'companyurl',
        'companyemail',
        'companyphone',
        'companyevoice',
        'companyevoiceint',
        'billingemail',
        'companymark',
        'companyyourreference',
        'pay_option1_bank',
        'pay_option1_iban',
        'pay_option1_bic',
        'companyindustries',
        'companydescription',
        'companylongdescription',
        'latitude',
        'longitude',
        'profile_facebook',
        'profile_twitter',
        'profile_linkedin',
        'profile_instagram',
        'profile_youtube',
        'profile_id',
        'profile_ext',
        'file_id',
        'file_ext',
        'mainimage_id',
        'mainimage_ext',
        'storefrontlogo_id',
        'storefrontlogo_ext',
        'sharedFile'
      ]
      const data = exportFields.reduce((a, e) => (a[e] = this.settings[e], a), {})
      data.companyprofile = 1
      data.version = this.version
      return data
    },
    async save (payment) {
      await this.awaitUploadsBeforeSave()
      this.saving = true
      const data = this.getSaveData()
      if (data.billingemail && !this.validateEmail(data.billingemail)) {
        this.saving = false
        this.applyPendingUploads()
        return this.showError(this._('Invalid email address'))
      }
      let response
      try {
        if (data.id) {
          response = await axios.put(this.baseDomain + this.shopId + '/settings/1.json?apikey=' + this.apiKey, data)
        } else {
          this.saving = false
          this.applyPendingUploads()
          return
        }
      } catch(e) {
        this.saving = false
        this.applyPendingUploads()
        return this.showError(e)
      }
      this.saving = false
      this.saved = true
      this.storeState()
      this.applyPendingUploads()
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.settings)
      this.close()
    },
    loadVersionedSettings () {
      return new Promise(async (resolve, reject) => {
        const settings = await this.loadSettings()
        resolve(settings)
      })
    },
    validateEmail (email) {
      if (email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    Editor,
    JohkuMaxSubscription,
    LocationSelector
  },
  async mounted () {
    const settings = await this.loadVersionedSettings()
    this.origSettings = Object.assign({}, settings)
    this.localSettings = Object.assign({}, settings)
    this.storeState()
    this.applyPendingUploads()
    this.loadIndustries()
    this.loadLicenseData()
  }
}
</script>